<ng-container *ngIf="config && config.panels">
        <div *ngFor="let panel of config.panels" [id]="panel.id" [class]="'xsPanel '+panel.dock+ panel.height?'height-'+panel.height:''">
            <xs-debug label="panel"  [item]="panel"></xs-debug>
            <ng-container *ngIf="panel.header">
                <div [class]="'row header ' + (panel.header.height?'height-'+panel.header.height:'')">
                    <xs-debug label="header" [item]="panel.header"></xs-debug>
                    <ng-container *ngIf="panel.header.items">
                        <xs-panel-items [config]="panel.header"></xs-panel-items>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="panel.content">
                <div [class]="'row content ' + (panel.content.height?'height-'+panel.content.height:'')">
                    <xs-debug label="content" [item]="panel.content"></xs-debug>
                    <ng-container *ngIf="panel.content.items">
                        <xs-panel-items [config]="panel.content"></xs-panel-items>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="panel.panels">
                <xs-panel [config]="panel"></xs-panel>
            </ng-container>
        </div>
    </ng-container>